module.exports = __webpack_public_path__ + "img/RA_Logo_Bug-LeftText_white.ab19e9e9.ab19e9e9.svg";